module.exports = __webpack_public_path__ + "img/human8logo-secondary.95a85211.png";